import React from 'react';
export function Footer() {
  return <footer className="bg-brand-darker py-16 px-4 sm:px-6 lg:px-8 border-t border-brand-green/10 text-center" data-id="element-98">
      <div className="max-w-4xl mx-auto" data-id="element-99">
        <div className="text-3xl font-black text-brand-green mb-6 tracking-wider" data-id="element-100">
          MODODIGITAL™
        </div>

        <p className="text-lg font-medium text-white mb-2" data-id="element-101">
          El sistema N°1 de transformación física en casa para Argentina
        </p>
        <p className="text-gray-400 mb-12" data-id="element-102">
          Porque bajar la panza no debería costarte todos los lunes del año.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm text-gray-500 mb-12" data-id="element-103">
          <a href="mailto:soporte.mododigital@gmail.com" className="hover:text-brand-green transition-colors flex items-center gap-2" data-id="element-104">
            📧 soporte.mododigital@gmail.com
          </a>
          <a href="https://www.mododigital.shop" className="hover:text-brand-green transition-colors flex items-center gap-2" data-id="element-105">
            🌐 www.mododigital.shop
          </a>
        </div>

        <div className="text-xs text-gray-600 space-y-4" data-id="element-106">
          <p data-id="element-107">© ModoDigital™ 2026 — Todos los derechos reservados</p>
          <p className="italic" data-id="element-108">"El próximo lunes puede ser diferente."</p>
        </div>
      </div>
    </footer>;
}